import { useQuery } from 'react-query';
import { NarrativeRequest } from 'utilitys/narrative/narrativeTools';

import { getWidgetData as queryFn } from 'api/endPoints/getWidgetData';
import { QueryKeys } from 'api/queryKeys';

import {
    IAssignee,
    IStatus,
} from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/battlecards.types';

export const useQueryActivityPrediction = (params: QueryParams, endpoint?: string) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['activityPrediction', params],
        queryFn: () => queryFn(params, endpoint),
        enabled: Boolean(params.hashCode) && Boolean(params.versionId),
    });
};

interface QueryResponse extends NarrativeRequest {
    taskId: number;
    activityId: string;
    name: string;
    status: IStatus;
    assignee: IAssignee;
    planedFinishDate: number | null;
    optimisticFinishDate: number | null;
    optimisticFinishVariance: number | null;
    bestFinishDate: number | null;
    bestFinishVariance: number | null;
    pessimisticsFinishDate: number | null;
    pessimisticsFinishVariance: number | null;
    baselineFinishDate: number | null;
    baselineFinishVariance: number | null;
    isVirtual: boolean;
    info: IToolTip;
    probability: number;
}

interface QueryParams {
    hashCode?: string | null;
    versionId?: number;
}
